export type Pence = number;
export type Pounds = number;

export const PENCE_IN_POUND = 100;
